// extracted by mini-css-extract-plugin
module.exports = {"generalStateResultsWrapper":"generalStateResults_generalStateResultsWrapper__WJfdd"};